/* eslint-disable camelcase */
import { APIBlock } from "@companion-core/shared/app/Interfaces/API";

export interface Block {
  id: string;
  type: string;
  slug: string;
  display_type: string;
  subBlocks?: APIBlock[];
  order?: number;
}

export interface PageContainerProps {
  children?: React.ReactNode;
  pageContainsVerticalList?: boolean;
  pageUsesFillLayout?: boolean;
  shouldHideHeaderOnScroll?: boolean;
}

export interface BlockContainerProps {
  key?: string;
  children?: React.ReactNode;
  fillLayout?: boolean;
}

export const transformPageBlocksWithTabContainer = (apiBlocks: APIBlock[]) => {
  const tabBlocks: APIBlock[] = [];
  const pageBlocks: Block[] = [];
  apiBlocks?.forEach((apiBlock) => {
    if (apiBlock.type === "tab") {
      tabBlocks.push(apiBlock);
    } else {
      pageBlocks.push(apiBlock);
    }
  });
  if (tabBlocks.length) {
    pageBlocks.push({
      id: "tab-container",
      type: "tab-container",
      slug: "tab-container",
      display_type: "tab-container",
      subBlocks: tabBlocks,
      order: tabBlocks[0]?.order,
    });
  }
  pageBlocks.sort((blockA, blockB) =>
    blockA?.order && blockB?.order ? blockA?.order - blockB?.order : 0
  );
  return pageBlocks;
};
